import { AppProviders } from './providers'

export const App = () => <AppProviders />
